import { getSchoolByID, isSchoolsReady } from "state/school_money/selectors";

function getParents(state) {
  return state.getIn(["school_money", "parents"]);
}

/**
 * @returns {boolean}
 */
export function areAllParentEmailAddressesSet(state) {
  if (!isParentsReady(state)) {
    return false;
  }
  const parents = getParents(state);
  return parents.every(parent => parent.emailAddress !== "");
}

/**
 * @returns {Immutable.List}
 */
export function getParentsLackingEmailAddresses(state) {
  const parents = getParents(state);
  return parents.filter(parent => parent.emailAddress === "").toList();
}

/**
 * @returns {Immutable.List}
 */
export function getSchoolsLackingParentEmailAddresses(state) {
  const parents = getParentsLackingEmailAddresses(state);
  return parents.map(parent => getSchoolByID(state, parent.schoolID));
}

/**
 * @returns {boolean}
 */
export function isParentsReady(state) {
  if (!isSchoolsReady(state)) {
    return false;
  }
  return !state.getIn(["school_money", "isParentsLoading"]);
}

/**
  * @returns {list}
  */
export function getParentInSchool(state, schoolID) {
  return getParents(state).filter(parent => parent.schoolID === schoolID).toList();
}

/**
  * @returns {string}
  */
export function getParentEmailAddress(state, schoolID) {
  const parents = getParentInSchool(state, schoolID);
  return parents.first().emailAddress;
}

/**
  * @returns {string}
  */
export function getParentFirstName(state, schoolID) {
  const parents = getParentInSchool(state, schoolID);
  return parents.first().firstName;
}

/**
  * @returns {string}
  */
export function getParentLastName(state, schoolID) {
  const parents = getParentInSchool(state, schoolID);
  return parents.first().lastName;
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/parents.js